import type { AxiosPromise } from 'axios';

import type { JobSummaryDto, JobSummaryType } from '../model';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';

import type { AutoProcessAtsVacancyPayloadDto, AutoProcessAtsVacancyResponseDto } from '../model';

class JobImprovedSelectionClient extends BaseClient {
  listJobSummaries(search?: string, type?: JobSummaryType[]): AxiosPromise<JobSummaryDto[]> {
    return this.request({
      url: `${hosts.reachoutApi}/combined-vacancies/`,
      method: 'GET',
      params: {
        ...(search && { starts_with: search }),
        ...(type?.length && { type }),
      },
    });
  }

  autoProcessAtsVacancy(payload: AutoProcessAtsVacancyPayloadDto): AxiosPromise<AutoProcessAtsVacancyResponseDto> {
    return this.request({
      url: `${hosts.reachoutApi}/auto-process-ats-vacancy/`,
      method: 'POST',
      data: payload,
    });
  }
}

export const jobImprovedSelectionClient = new JobImprovedSelectionClient();
